import React from 'react';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { HighlightTitle } from '@zola/zola-ui/src/components/PreAuthV3';

import { ContactSectionWrapper, TitleWrapper, Information } from './ContactSection.styles';

const ContactSection: React.FC = (): JSX.Element => {
  return (
    <ContactSectionWrapper>
      <TitleWrapper>
        <HighlightTitle isH1={false}>
          Contact <strong>customer support</strong>
        </HighlightTitle>
      </TitleWrapper>
      <Information>
        We&#8217;re just a click away, 7 days a week, 10am&ndash;6pm EST. <br />
        Reach out to Team-Z at{' '}
        <LinkV2 subtle noTextTransform href="mailto:support@zola.com">
          support@zola.com
        </LinkV2>
      </Information>
      <ButtonV3 component="a" href="mailto:support@zola.com" size="large">
        Get in touch
      </ButtonV3>
    </ContactSectionWrapper>
  );
};

export default ContactSection;
